export class GetDanfePackingLabelInput {
    orderIds: number[];
}